<template>
    <div class="lightbox"
    :style="!active ? 'display: none;' : 'display:flex;'"
    @click.prevent="closeLightbox()"
    >
        <div class="lightbox__container">
            <div class="lightbox__inner">
                <img :src="fullImg" class="w-full realative h-full object-contain object-center" />
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'light-box',
    emits: ['activeLightbox'],
    props: {
        fullImg: {
            type: String,
            default: ''
        },
        setActive: {
            type:Boolean,
            default:true
        }
    },
    data() {
        return {
            active: this.setActive,
        }
    },
    mounted() {
        console.log(this.fullImg)
    },
    methods:{
        closeLightbox(){
            this.$emit('activeLightBox',!this.active) 
        }
    }
}
</script>

<style lang="scss" scoped>
.lightbox {
    position: fixed;
    background: rgba(0, 0, 0, 0.6196078431);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    top: 0;
    left: 0;
    padding: 200px;
    @screen mdr{
        padding:5px;
    }


    &__container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    &__inner {
        padding: 10px;
        background: #fff;
    }
}</style>